import React from 'react';
import { connect } from 'react-redux';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import PostAuthActionProvider from 'dpl/auth/components/PostAuthActionProvider';
import UserAuthModalV2 from 'dpl/auth/components/UserAuthModalV2';
import {
  FOLLOWABLE_ID,
  FOLLOWABLE_TYPE,
  REACTIONABLE_ID,
  REACTIONABLE_TYPE
} from 'dpl/constants/query_params';
import { SIGNUP_REF_ACTION } from 'dpl/auth/utils/constants';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';

const { BREEDER_SIGNUP, FORGOT_PASSWORD, LOGIN, SIGNUP } = SIGNUP_FORM_TYPES;

function UserAuthModalContainer(props) {
  return (
    <>
      <PostAuthActionProvider />
      <UserAuthModalV2 {...props} />
    </>
  );
}

export default connect(({ queryParams }) => ({ queryParams }), {
  onBreederSignupClick() {
    return pushParams({ direct_signup: BREEDER_SIGNUP }, { hash: true });
  },
  clearParams() {
    return resetParams(
      'direct_signup',
      SIGNUP_REF_ACTION,
      FOLLOWABLE_TYPE,
      FOLLOWABLE_ID,
      REACTIONABLE_TYPE,
      REACTIONABLE_ID,
      { hash: true }
    );
  },
  onLoginClick() {
    return pushParams({ direct_signup: LOGIN }, { hash: true });
  },
  onPasswordResetClick() {
    return pushParams({ direct_signup: FORGOT_PASSWORD }, { hash: true });
  },
  onSignupClick() {
    return pushParams({ direct_signup: SIGNUP }, { hash: true });
  }
})(UserAuthModalContainer);
